import React from "react"
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {FilterExpander} from "../common/FilterExpander";
import AssociateFilter from "./AssociateFilterV2";
const AssociateFilterWrapperV2 = () => {
    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <AssociateFilter />
                </FilterExpander> :
                <AssociateFilter />}
        </React.Fragment>
    )

}
export default AssociateFilterWrapperV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociateFilterWrapperV2.js